<template>
    <!-- 落布标签列表 -->
    <div class="rzy-page">
        <d-query-input :options="options" @query="queryBySelect" @clear="clearQuery" width="500px"
            :pageInfo="pageInfo" />
        <el-table :data="labelListData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
            border>

            <!--落布标签数据-->
            <el-table-column v-for="(obj,name,index) in labelListTime" :key="index" :label="obj.value"
                :align="obj.align" :width="obj.width">
                <template slot-scope="data">
                    <div v-for="(item, index) in data" :key="index">
                        {{ item[name] }}
                    </div>
                </template>
            </el-table-column>





            <el-table-column label="落布标签号"  align="center">
                <template slot-scope="data">
                    <el-link type="primary" @click="labelDetailsShow(data.row)">{{data.row.productLableNumber}}
                    </el-link>
                </template>
            </el-table-column>
            <!--      <el-table-column label="生产单号" width="90" align="center">
	          <template slot-scope="data">
	            <el-link type="primary" @click="goToProductDetails(data.row.productOrderId)">{{data.row.productOrderNumber}}</el-link>
	          </template>
	        </el-table-column> -->
            <el-table-column label="工单号"  align="center">
                <template slot-scope="data">
                    <el-link type="primary" @click="$refs.workOrderDetails.show(data.row.parentId)">
                        {{data.row.workOrderNumber}}
                    </el-link>
                </template>
            </el-table-column>

            <el-table-column v-for="(obj,name,index) in labelListParams" :key="index" :label="obj.value"
                :align="obj.align" :width="obj.width">
                <template slot-scope="data">
                    <div v-for="(item, index) in data" :key="index">
                        {{ item[name] }}
                    </div>
                </template>
            </el-table-column>
			
			<el-table-column prop="status_change" label="状态" align="center" width="100">
			</el-table-column>


        </el-table>
        <el-pagination style="text-align: center" background layout="prev, pager, next"
            @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
            :page-count="totalPages">
        </el-pagination>
        <work-order-details ref="workOrderDetails" />
        <label-details ref="labelDetails" />
    </div>
</template>

<script>
    import {
        workOrderDetails,
        dQueryInput
    } from '@/components/projectComponents'
    import {
        labelDetails
    } from './components'
    // import * as api from '@/api/factory/product/labelList'
    export default {
        components: {
            workOrderDetails,
            dQueryInput,
            labelDetails
        },
        data() {
            return {
                totalPages: 0,
                pageInfo: {
                    page: 1,
                    size: 20
                },
                labelListParams: {
					productName: {
						value: '落布名称',
						align: 'center',
						width: '120'
					},
                    machineName: {
                        value: '机台(车间)',
                        align: 'center',
                        width: '120'
                    },
                    batchNumber: {
                        value: '批号',
                        align: 'center',
                        width: '70'
                    },
                    defectCount: {
                        value: '疵点',
                        align: 'center',
                        width: '70'
                    },
                    tingcheCount: {
                        value: '停车痕',
                        align: 'center',
                        width: '70'
                    },
                    productLength: {
                        value: '布匹长度(米)',
                        align: 'center',
                        width: '100'
                    },
                    realWeight: {
                        value: '布匹重量(千克)',
                        align: 'center',
                        width: '100'
                    },
                    doorNumber: {
                        value: '幅号',
                        align: 'center',
                        width: '70'
                    },
                    doorWidth: {
                        value: '幅宽',
                        align: 'center',
                        width: '70'
                    },
                    squareGrams: {
                        value: '平方克',
                        align: 'center',
                        width: '70'
                    }
                },

                labelListTime: {
                    startTime: {
                        value: '开始时间',
                        align: 'center',
                   
                    },
                    endTime: {
                        value: '结束时间',
                        align: 'center',
                    
                    }
                },


                labelListData: [],
                options: [{
                    label: '生产单号',
                    value: 'productOrderNumber'
                }, {
                    label: '工单号',
                    value: 'workOrderNumber'
                }]
            }
        },
        methods: {
			labelDetailsShow(data) {
				this.$refs.labelDetails.show(data)
			},
            // 分页切换
            handleCurrentChange(newNum) {
                this.pageInfo.page = newNum
                this.changePage(newNum)
            },
            // 获取落布标签分页列表
            changePage(val) {
                this.pageInfo.page = val
                this.$requestBase({
                    url: 'v1/factory/product-order/work-order/down-cloth/page',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.labelListData = this.formatResponse(res.data.list)
                    this.totalPages = res.data.pages
                })
            },
            // 格式化落布标签列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    item.machineName = `${item.machineNumber}(${item.machineWorkShop})`
                    item.startTime = this.utils.timestampToTime(item.startTime)
                    item.endTime = this.utils.timestampToTime(item.endTime)
                    item.productLength = item.productLength / 100
                    item.labelNum = item.workOrderNumber + item.doorNumber + item.batchNumber
                    item.realWeight = item.realWeight ? item.realWeight : item.upWeight
                    item.realWeight = this.utils.toKg(item.realWeight)

                    // console.log("item.status=", item.status)
                    if(item.status == 1){
                        item.status_change = '已入库'
                    }else if(item.status == 2){
                        item.status_change = '已出库'
                    }else if(item.status == 3){
						item.status_change = '已出货'
					}
                })
                return response
            },
            // 条件查询
            queryBySelect(pageInfo) {
                this.pageInfo = pageInfo
                this.changePage(1)
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo
                this.changePage(1)
            },
            // 路由至生产单详情
            goToProductDetails(productOrderId) {
                this.$router.push(`productOrderList/productOrderDetalis/${productOrderId}`)
            }
        },
        mounted() {
            this.changePage(1)
        },
        watch: {
            $route() {
                this.changePage(1)
            }
        }
    }
</script>

<style lang='scss' scoped>
    .detable {
        margin: 10px 0 0 -10px;
    }
</style>
